import { useState, useEffect } from 'react';
import { supabase } from '../services/supabaseClient';

export const useAuth = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isRecovery, setIsRecovery] = useState(false);

  useEffect(() => {
    const checkHash = () => {
      const h = window.location.hash;
      return h.includes('access_token=') || h.includes('type=recovery') || h.includes('type=invite');
    };

    if (checkHash()) setIsRecovery(true);

    const { data: listener } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === 'PASSWORD_RECOVERY' || (event === 'SIGNED_IN' && checkHash())) {
        setIsRecovery(true);
      }
      setUser(session?.user ?? null);
      setLoading(false);
    });

    supabase.auth.getSession().then(({ data: { session } }) => {
      setUser(session?.user ?? null);
      setLoading(false);
    });

    return () => listener.subscription.unsubscribe();
  }, []);

  const logout = async () => {
    await supabase.auth.signOut();
    setUser(null);
    setIsRecovery(false);
    window.location.replace('/login');
  };

  return { user, loading, isRecovery, setIsRecovery, logout };
};